import React, { useState, useEffect } from 'react'
import styles from './branch_map.css'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import Gmap from '../../assets/google_map.png'
import Phone from '../../assets/centre_phone.png'
import { FETCH_BRANCHES } from 'constants/actionTypes'
import useGetApi from 'api/useGetApi'
import CONFIG from 'config'
import {trackWebEngageEvent, params as webengage_params} from '../../utils/customWebengageEvents'

const Branchmapsection = (props) => {
    const apiData = {
        success: true,
        msg: 'success',
        data: [
            {
                center_name: 'Aakash Institute-Chandigarh Branch',
                address: 'SCO 121, 122 & 123, Sector 34A, Sector 34, Chandigarh',
                contact_numbers: [
                    '8800013079',
                    '828407218',
                    '8989898980',
                    '5676776777',
                ],
                location_url: 'https://maps.app.goo.gl/QgqwtChtQ2h2Xvj37',
            },
            {
                center_name: 'Aakash Institute-Chandigarh Branch',
                address: 'SCO 121, 122 & 123, Sector 34A, Sector 34, Chandigarh',
                contact_numbers: [
                    '8800013079',
                    '828407218',
                    '8989898980',
                    '5676776777',
                ],
                location_url: 'https://maps.app.goo.gl/QgqwtChtQ2h2Xvj37',
            },
            {
                center_name: 'Aakash Institute-Chandigarh Branch',
                address: 'SCO 121, 122 & 123, Sector 34A, Sector 34, Chandigarh',
                contact_numbers: [
                    '8800013079',
                    '828407218',
                    '8989898980',
                    '5676776777',
                ],
                location_url: 'https://maps.app.goo.gl/QgqwtChtQ2h2Xvj37',
            },
        ],
    }
    const [branchDetails, setBranchDetails] = useState(apiData.data)

    const Domain = window.location.hostname
    const isAkTheDomain = Domain.includes('akthedashboard');

    const {
        data: brancData,
        loading,
        error,
        setEnabled: fetchBranchData,
    } = useGetApi(
        CONFIG.FETCH_BRANCHES + props.profileData.exam_center_id + '?exam_type=' + props.profileData.exam_type,
        props?.token,
        true,
    )
    useEffect(() => {
        fetchBranchData(true)
    }, [])
    useEffect(() => {
        if (brancData && brancData.data) {
            let details = brancData.data
            if (props.NearestBranch || props.soloBranch) {
                setBranchDetails([details[0]])
                localStorage.setItem('center-address', details[0]?.contact_numbers);
                localStorage.setItem('center-phone', details[0]?.address);
                localStorage.setItem('center-gps', details[0]?.location_url);
            } else {
                setBranchDetails(details)
            }
        }
    }, [brancData])

    let nearBranchesEvent = (branch) => {
        let nearBranchParam = JSON.parse(JSON.stringify(webengage_params));
        nearBranchParam = {
            ...nearBranchParam,
            gps_link: branch?.location_url,
            center_phone_numbers: branch?.contact_numbers?.join().replace(/[\r\n\\]+/g, ''),
            center_address: branch?.address,
            center_name: branch?.center_name,
            center_code: branch?.center_code
        }
        trackWebEngageEvent(isAkTheDomain?'AKTHE_db_pr_branches_near_you':'Anthe_db_pr_branches_near_you', nearBranchParam);
    };

    return (
        <div>
        <div className="branchbox">
            {branchDetails && branchDetails.length > 0
                ? branchDetails.map((ele, index) => {
                      return (
                          <Col key={index}
                                xs={props.NearestBranch ? 12 : 11}
                                md={props.NearestBranch ? 12 : 6}
                                lg={props.isResultPage? 4 : props.NearestBranch ? 12 : 8}
                                xl={props.isResultPage?4:props.NearestBranch ? 12 : 6}
                              className="branchdetailsbox"
                          >
                            {(ele?.registered_branch && props?.isResultPage) && (<span className='bg-dark-green text-white font-size-xs fw-semibold text-center p-1 pe-3 ps-3 rounded selected_branch '>Selected Branch</span>)}
                              <Card
                                  className={`${props.isResultPage?'border mx-lg-0':'border-0 mx-lg-2'} ${props.NearestBranch ? 'bg-beige' : ''} pb-3 p-md-3 p-2 mb-3 mx-0`}
                                  style={{
                                      boxShadow: props.isResultPage?'':'0px 2px 8px rgba(0, 0, 0, 0.15)',
                                      minHeight: '75%',
                                      height: '100%',
                                    //   position: 'absolute',
                                    //   top: '0px',
                                      
                                  }} onClick={() => nearBranchesEvent(ele)}
                              >
                                  <CardHeader className={`border-0 bg-white fw-bold p-0 font-size-sm font-size-md-md mt-2 ${props.NearestBranch ? 'bg-beige' : 'bg-white'}`}>
                                      {ele.center_name}
                                  </CardHeader>
                                  <CardBody className="p-0 text-grey fw-lighter font-size-xs font-size-md-sm font-size-lg-md">
                                      <p
                                          style={{
                                              height: '40%',
                                              maxHeight: '40%',
                                          }}
                                      >
                                          {ele.address}
                                      </p>
                                      <Row className="ps-2 p-0 my-2">
                                          <Col xs={7} md={8} className="p-0 ps-2">
                                              <p className="text-warning mb-1 mb-lg-2">
                                                  Open until 07:00 PM
                                              </p>
                                              <Row className="m-0 p-0 justifyc-content-center">
                                                  <Col xs={2} className="p-0">
                                                      <img src={Phone} />
                                                  </Col>
                                                  <Col className={`font-size-xxs font-size-md-xs ${props.NearestBranch ? 'font-size-lg-sm' : 'font-size-lg-md'} fw-lighter p-0`}>
                                                      <p className="mb-1">
                                                          <a
                                                              href={
                                                                  'tel:' +
                                                                  ele
                                                                      .contact_numbers[0]
                                                              }
                                                              className={`text-aqua me-2`}
                                                              //   onClick={handleCallNow}
                                                          >
                                                              {
                                                                  ele
                                                                      .contact_numbers[0]
                                                              }
                                                          </a>
                                                          &nbsp;
                                                          <a
                                                              href={
                                                                  'tel:' +
                                                                  ele
                                                                      .contact_numbers[1]
                                                              }
                                                              className={`text-aqua`}
                                                              //   onClick={handleCallNow}
                                                          >
                                                              {
                                                                  ele
                                                                      .contact_numbers[1]
                                                              }
                                                          </a>
                                                          &nbsp;
                                                      </p>
                                                      <p className="mb-1">
                                                          <a
                                                              href={
                                                                  'tel:' +
                                                                  ele
                                                                      .contact_numbers[2]
                                                              }
                                                              className={`text-aqua me-2`}
                                                              //   onClick={handleCallNow}
                                                          >
                                                              {
                                                                  ele
                                                                      .contact_numbers[2]
                                                              }
                                                          </a>
                                                          &nbsp;
                                                          <a
                                                              href={
                                                                  'tel:' +
                                                                  ele
                                                                      .contact_numbers[3]
                                                              }
                                                              className={`text-aqua`}
                                                              //   onClick={handleCallNow}
                                                          >
                                                              {
                                                                  ele
                                                                      .contact_numbers[3]
                                                              }
                                                          </a>
                                                          &nbsp;
                                                      </p>
                                                      {/* {groupContacts(ele.contact_numbers)} */}
                                                  </Col>
                                              </Row>
                                          </Col>
                                          <Col xs={4} className="ps-0">
                                              <a
                                                  href={ele.location_url}
                                                  target="blank"
                                              >
                                                  <img
                                                      alt={'google_map_link'}
                                                      src={Gmap}
                                                  />
                                              </a>
                                          </Col>
                                      </Row>
                                  </CardBody>
                              </Card>
                          </Col>
                      )
                      
                  })
                : ''}
        </div>
        </div>
    )
}
export default Branchmapsection
